import AddUserMethod from '@/interfaces/addUserMethod';
import CourseCodeUserCreator from './CourseCodeUserCreator';
import { CreateUserArgs } from './createUserArgs';
import DirectJoinUserCreator from './directJoinUserCreator';
import InvitationUserCreator from './InvitationUserCreator';
import IUserCreator from './iUserCreator';
import LtiUserCreator from './ltiUserCreator';
import CredentialUserCreator from './credentialUserCreator';

export class UserCreatorFactory
{
    static create<T extends AddUserMethod>(method: T, args: CreateUserArgs<T>): IUserCreator
    {
        switch (method) {
            case AddUserMethod.invitation:
                return new InvitationUserCreator(args as CreateUserArgs<AddUserMethod.invitation>);
            case AddUserMethod.courseCode:
                return new CourseCodeUserCreator(args as CreateUserArgs<AddUserMethod.courseCode>);
            case AddUserMethod.lti:
                return new LtiUserCreator(args as CreateUserArgs<AddUserMethod.lti>)
            case AddUserMethod.directJoin:
                return new DirectJoinUserCreator(args as CreateUserArgs<AddUserMethod.directJoin>);
            case AddUserMethod.credential:
                return new CredentialUserCreator(args as CreateUserArgs<AddUserMethod.credential>);
            default:
                throw new Error(`No creation process for user creation method '${method}'.`);
        }
    }
}
